import { cardProductSchema, zSchema } from "@zeal/common";

export const getPayCardArtResponseSchema = zSchema.object({
  cardProducts: zSchema.array(cardProductSchema),
  frontCardArt: zSchema.string(),
  backCardArt: zSchema.string(),
});

export type TGetPayCardArtResponse = zSchema.infer<
  typeof getPayCardArtResponseSchema
>;
